import { ActionContext, ActionTree } from "vuex";
import { IDemoState, IDemoSubject } from "@/store/modules/demo/types";
import { IAnswer, RootState } from "@/store/types";
import { ApiCaller } from "@/ApiCaller";

type DemoActionContext = ActionContext<IDemoState, RootState>;
type DemoActionTree = ActionTree<IDemoState, RootState>;

export const actions: DemoActionTree = {
  async takeSection(context: DemoActionContext, subject: string): Promise<any> {
    const content = await ApiCaller.getInstance().get(
      `/demo/section/${subject}`
    );
    context.commit("setSection", content.data);
  },

  async fetchContentQuestions(
    context: DemoActionContext,
    section_id: number
  ): Promise<any> {
    const content = await ApiCaller.getInstance().get(
      `/demo/question/${section_id}`
    );
    context.commit("setQuestions", content.data);
  },

  async fetchContentPassages(
    context: DemoActionContext,
    section_id: number
  ): Promise<any> {
    const content = await ApiCaller.getInstance().get(
      `/demo/passages/${section_id}`
    );
    context.commit("setPassages", content.data);
  },

  async finishSection(
    context: DemoActionContext,
    payload: {
      subject: string;
      usectionId: number;
      timeRemain: number;
      answers: any;
      completedSections: {};
    }
  ): Promise<any> {
    await context.dispatch("saveCompletedSections", payload.completedSections);
  },

  async saveCompletedSections(
    context: DemoActionContext,
    completedSections: {}
  ): Promise<any> {
    context.commit("setCompletedSections", completedSections);
  },
};
